export const HEADER_NAV_ITEMS = [
  { to: '/products/chorna', key: 'chorna' },
  { to: '/products/tactical-drones', key: 'tacticalDrones' },
  { to: '/products/iris', key: 'jade' },
 ] as const;

export const HEADER_COMPANY_ITEMS = [
  { to: '/about', key: 'about' },
  { to: '/team', key: 'coreTeam' },
] as const;

export const MENU_NAV_ITEMS = [
  { to: '/', key: 'home' },
  ...HEADER_NAV_ITEMS,
] as const;

export type HeaderNavItemKey = (typeof HEADER_NAV_ITEMS)[number]['key'];
export type HeaderCompanyNavItemKey = (typeof HEADER_COMPANY_ITEMS)[number]['key'];
export type MenuNavItemKey = (typeof MENU_NAV_ITEMS)[number]['key'];
